import * as React from 'react';
import { useReferenceOverflowButton_unstable } from './useReferenceOverflowButton';
import { renderReferenceOverflowButton_unstable } from './renderReferenceOverflowButton';
import { useReferenceOverflowButtonStyles_unstable } from './useReferenceOverflowButtonStyles.styles';
import type { ReferenceOverflowButtonProps } from './ReferenceOverflowButton.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// ReferenceOverflowButton component - TODO: add more docs
export const ReferenceOverflowButton: ForwardRefComponent<ReferenceOverflowButtonProps> = React.forwardRef(
  (props, ref) => {
    const state = useReferenceOverflowButton_unstable(props, ref);

    useReferenceOverflowButtonStyles_unstable(state);
    return renderReferenceOverflowButton_unstable(state);
  },
);

ReferenceOverflowButton.displayName = 'ReferenceOverflowButton';
